import { render, staticRenderFns } from "./AdminPatientVerificationDetail.vue?vue&type=template&id=36b2694f"
import script from "./AdminPatientVerificationDetail.vue?vue&type=script&lang=js"
export * from "./AdminPatientVerificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports